/**
 * In-flight + session result cache so shell APIs (settings, sellers, summary, …)
 * are requested once per login even when layout + page mount together.
 */
export function createSharedApiSession () {
  var values = Object.create(null)
  var inflight = Object.create(null)

  return {
    get: function (key, loader, force) {
      if (!force && Object.prototype.hasOwnProperty.call(values, key)) {
        return Promise.resolve(values[key])
      }
      if (!force && inflight[key]) return inflight[key]
      inflight[key] = Promise.resolve()
        .then(loader)
        .then(function (value) {
          values[key] = value
          delete inflight[key]
          return value
        }, function (err) {
          delete inflight[key]
          return Promise.reject(err)
        })
      return inflight[key]
    },
    clear: function (key) {
      if (key == null) {
        values = Object.create(null)
        inflight = Object.create(null)
        return
      }
      delete values[key]
      delete inflight[key]
    },
    peek: function (key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : undefined
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/sharedApiSession.js